import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import licensService from "./licensService";

const initialState = {
    isSuccess: false,
    isLoading: false,
    isError: false,
    errors: null,
};

export const GetSingleLicens = createAsyncThunk(
    "licens/single",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await licensService.GetSingleLicens(id, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.errors);
        }
    }
);

export const CreateLicens = createAsyncThunk(
    "licens/single",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await licensService.CreateLicens(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
);

export const UpdateSingleLicens = createAsyncThunk(
    "licens/single",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await licensService.UpdateSingleLicens(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
);
export const DeleteSingleLicens = createAsyncThunk(
    "licens/single",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await licensService.DeleteSingleLicens(id, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.errors);
        }
    }
);

const LicensSlice = createSlice({
    name: "licens",
    initialState,
    reducers: {
        licensReset: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
        },
    },
    extraReducers: {
        // Get Single Licens
        [GetSingleLicens.pending]: (state) => {
            state.isLoading = true;
        },
        [GetSingleLicens.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.licens = action.payload;
        },
        [GetSingleLicens.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Update Single Licens
        [UpdateSingleLicens.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateSingleLicens.fulfilled]: (state) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [UpdateSingleLicens.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Create Single Licens
        [CreateLicens.pending]: (state) => {
            state.isLoading = true;
        },
        [CreateLicens.fulfilled]: (state) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [CreateLicens.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Delete Single Licens
        [DeleteSingleLicens.pending]: (state) => {
            state.isLoading = true;
        },
        [DeleteSingleLicens.fulfilled]: (state) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [DeleteSingleLicens.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },
    },
});

export const { licensReset } = LicensSlice.actions;
export default LicensSlice.reducer;
